import styled from "styled-components";
import { Modal } from "antd";
import DatatableAntd from "components/datatable-antd";
import { hexToRgba } from "../../../ModalPlanejamentoOperacoes/utils";

export const MODAL_CHROME_HEIGHT = 122;
export const TABLE_HEADER_HEIGHT = 55;
export const TABLE_ROW_HEIGHT = 47;
export const BODY_VERTICAL_PADDING = 37;

export const CustomModal = styled(Modal)`
  position: relative;
  max-height: 90vh;

  .ant-modal-content {
    border-radius: 10px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
  }

  .ant-modal-header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #12619C;
    height: 61px;
    flex-shrink: 0;
  }

  .ant-modal-title {
    color: #fff;
    font-weight: bold;
  }

  .ant-modal-close-x {
    color: #fff;
  }

  .ant-form-item-required::before {
      content: none !important;
    }

  .ant-form-item-required::after {
    display: inline-block !important;
    margin-left: 4px !important;
    color: red;
    font-size: 14px !important;
    line-height: 1 !important;
    content: "*" !important;
  }

  .ant-modal-body {
    padding: 0;
    position: relative;
    max-height: calc(90vh - ${MODAL_CHROME_HEIGHT}px);
    height: auto;
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;
    overflow: hidden;
  }

  .ant-modal-footer {
    height: 61px;
    flex-shrink: 0;
  }

  .inner-overlay {
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.45);
    z-index: 5;
    backdrop-filter: blur(2px);
  }
`;

export const ContainerTable = styled.div<{ $hasScroll?: boolean }>`
  flex: ${({ $hasScroll }) => ($hasScroll ? "1" : "0 0 auto")};
  min-height: 0;

  > div > div > div > div > div,
  > div > div > div > div > div > div,
  .ant-table-cell:has(input) {
    overflow: visible !important;
  }

  .css-0,
  .ant-table-wrapper,
  .ant-spin-nested-loading,
  .ant-spin-container,
  .ant-table,
  .ant-table-container {
    height: ${({ $hasScroll }) => ($hasScroll ? "100%" : "auto")};
  }

  position: relative;
  width: 100%;

  .ant-table {
    table-layout: fixed !important;
  }

  .ant-table-container {
    overflow: ${({ $hasScroll }) => ($hasScroll ? "hidden" : "visible")} !important;
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    white-space: nowrap;
  }

  .ant-select {
    cursor: text;
    min-width: 100px;
    border-radius: 0.375rem;
  }
  .ant-select-selector {
    height: 2.4rem;
  }
`;

export const ModalTableContentWrap = styled.div<{ $hasScroll?: boolean }>`
  display: flex;
  flex-direction: column;
  flex: ${({ $hasScroll }) => ($hasScroll ? "1" : "0 0 auto")};
  min-height: 0;
`;

export const RoundedTable = styled(DatatableAntd)`
  .ant-table {
    border-radius: 8px;
    overflow: hidden;
  }

  .ant-table-container {
    border-radius: 8px;
    overflow: hidden;
  }

`;

export const Type = styled.div<{ color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;

  background: ${({ color }) => hexToRgba(color, 0.1)};
  color: ${({ color }) => color};
  font-size: 10px;
  padding: 3px 6px;
`;

export const ModalContainer = styled.div<{ $hasScroll?: boolean }>`
  padding: 12px 24px;
  display: flex;
  flex-direction: column;
  flex: ${({ $hasScroll }) => ($hasScroll ? "1" : "0 0 auto")};
  min-height: 0;
`;

export const HeaderWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin: -12px -24px 12px;
  padding: 20px 24px;
  background: #f8fafc;
  border-bottom: 1px solid #e0e6ed;
`;

export const SummaryCard = styled.div`
  background: white;
  border-radius: 8px;
  padding: 14px 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const SummaryIcon = styled.div<{ color: string; backgroundColor: string }>`
  width: 36px;
  height: 36px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background-color: ${({ backgroundColor }) => backgroundColor};

  svg {
    color: ${({ color }) => color};
    font-size: 18px;
  }
`;

export const SummaryContent = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const SummaryValue = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1;
`;

export const SummaryLabel = styled.div`
  font-size: 11px;
  color: #64748b;
  margin-top: 3px;
`;

export const StatusDay = styled.div<{ warning?: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    font-size: 13px;
    cursor: help;
    ${({ warning }) => warning && 'color: #b91c1c;'}
`;

export const ContainerFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
`;

export const ButtonExportExcel = styled.button`
    padding: 9px 20px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    border: none;
    display: inline-flex;
    align-items: center;
    gap: 8px;

    background: rgb(0, 145, 87);
    color: white;

    > svg {
        font-size: 18px;
    }
`;